/** Shared Settings profile payload. Empty values are omitted so a save cannot wipe stored data. */

export const PROFILE_FIELD_LABELS = {
  max_hr: "Max HR",
  ftp: "FTP",
  weight_kg: "Weight",
  resting_hr: "Resting HR",
  height_cm: "Height",
  years_experience: "Years of experience",
  gender: "Gender",
  dob: "Date of birth",
  experience_level: "Experience level",
  default_sport: "Preferred sport",
  has_power_meter: "Power meter",
  unit_system: "Units",
};

export const PROFILE_FIELD_HINTS = {
  max_hr: "Max HR must be between 100 and 230 bpm (this is maximum HR, not average).",
  ftp: "FTP must be between 50 and 600 watts.",
  weight_kg: "Weight must be between 20 and 250 kg.",
  resting_hr: "Resting HR must be between 30 and 120 bpm (not average workout HR).",
  height_cm: "Height must be between 100 and 250 cm.",
  years_experience: "Years of experience must be between 0 and 80.",
};

const RANGE_CHECKS = [
  ["max_hr", 100, 230],
  ["ftp", 50, 600],
  ["resting_hr", 30, 120],
  ["weight_kg", 20, 250],
  ["height_cm", 100, 250],
  ["years_experience", 0, 80],
];

export function profileFieldErrors(payload) {
  const errors = {};
  for (const [key, min, max] of RANGE_CHECKS) {
    if (!(key in payload)) continue;
    const value = Number(payload[key]);
    if (!Number.isFinite(value) || value < min || value > max) {
      errors[key] = PROFILE_FIELD_HINTS[key];
    }
  }
  return errors;
}

export function buildProfileUpdate(form) {
  const payload = {};
  for (const [key, value] of Object.entries(form)) {
    if (value === "" || value == null) continue;
    if (key === "has_power_meter") {
      payload[key] = value === "yes";
      continue;
    }
    if (["max_hr", "ftp", "resting_hr", "years_experience"].includes(key)) {
      const parsed = parseInt(value, 10);
      if (!Number.isFinite(parsed)) {
        return {
          payload: null,
          error: `${PROFILE_FIELD_LABELS[key] || key} must be a whole number.`,
          field: key,
        };
      }
      payload[key] = parsed;
      continue;
    }
    if (["weight_kg", "height_cm"].includes(key)) {
      const parsed = parseFloat(value);
      if (!Number.isFinite(parsed)) {
        return {
          payload: null,
          error: `${PROFILE_FIELD_LABELS[key] || key} must be a number.`,
          field: key,
        };
      }
      payload[key] = parsed;
      continue;
    }
    payload[key] = value;
  }
  const errors = profileFieldErrors(payload);
  const firstField = Object.keys(errors)[0];
  if (firstField) {
    return { payload: null, error: errors[firstField], field: firstField, errors };
  }
  return { payload, error: null, errors };
}
